import Segment from '@/common/utils/tracking/segment'

export default {
  /**
   * tracking call for navigation menu
   */
  trackNavMenuItemClick(buttonId: string) {
    Segment.track('App - Settings Navigation - Menu Item Clicked ', { buttonId })
  },

  /**
   * tracking call for top menu
   */
  trackTopMenuItemClick(buttonId: string) {
    Segment.track('App - Top Menu - Menu Item Clicked ', { buttonId })
  },
}
